import React from 'react'
import {Grid, Select, MenuItem, InputLabel,FormControl,} from '@material-ui/core'
import IntlMessages from 'util/IntlMessages';

export default function MainValueSettings(props) {
  return (
    <Grid item xs="12">
    <FormControl variant='outlined' fullWidth size='small'>
      <InputLabel id="demo-simple-select-label"><IntlMessages id="Label.main.Value"/></InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label={<IntlMessages id="Label.main.Value"/>}
          value={props.mainValue}
          onChange={(e) => props.setmainValue(e.target.value)}
        >
          <MenuItem value={"default"}><IntlMessages id="Label.default"/></MenuItem>
          <MenuItem value={"Utpris"}><IntlMessages id="input.Utpris"/></MenuItem>
          <MenuItem value={"TB"}><IntlMessages id="input.TB"/></MenuItem>
        </Select>
      </FormControl>
    </Grid>
  )
}
